/* Each range band adds its own actual Shopify variant. The existing drawer owns display. */
document.querySelectorAll('[data-product-add]').forEach(button => {
  button.addEventListener('click', async event => {
    event.preventDefault();
    if (button.disabled || button.dataset.busy === 'true') return;
    button.dataset.busy = 'true';
    const error = button.closest('section').querySelector('[data-product-cart-error]');
    if (error) error.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: button.dataset.productAdd, quantity: 1}]})
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || 'We could not add this item. Please try again.');
      await window.EHQCart.open();
    } catch (failure) { if (error) error.textContent = failure.message; }
    finally { delete button.dataset.busy; }
  });
});
